#import "../../../../common/graphql/EntityDocumentsFields.graphql"

query Approval($id: UUID!) {
  approval(id: $id) {
    id
    __typename
    _urgencyLevel
    _rowTimestamp
    _fullApprovalDescription
    _isApproved
    isPrimary
    isNewApprovalSelectable
    approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
      nodes {
        id
        requesterName
        requestedDate
        amount1
        currencyIsoCode
        isApprovalTreeViewerAllowed
        iconType {
          iconType
          iconState
        }
        statusType {
          statusType
        }
      }
    }
    approvalHistorySignaturesByEntityId(
      orderBy: SORT_ORDER_ASC
      filter: {
        not: {
          isApproved: { equalTo: false }
          isRejected: { equalTo: false }
          isRequested: { equalTo: false }
        }
      }
    ) {
      nodes {
        id
        additionalInformation
        digitalSignature
        actionDate
        isApproved
        isRejected
        isRequested
        userName
        entityDocumentId
        userOccupationTitle
        userSignatureDocument {
          id
          _downloadLink
          fileIndexInformation
          fileReference
          iconType
        }
      }
    }
    approvalType {
      id
      approvalType
      layoutType
    }
    id
    approvalTypeId
    _isStagedApprovalRequest
    _isApprovalRevocable
    isAddApproversEligible
    isNewProjectIncluded
    isDelayedApproverAllowed
    _rowTimestamp
    _isDeletable
    _isUpdatable
    statusType {
      statusType
      approvalState
      _transactionIconStatus
    }
    name
    priorityNumber
    description
    isDraft
    approvalPhaseTypeId
    approvalPhaseType {
      id
      phaseName
    }
    approvalTrees(orderBy: APPROVAL_LEVEL_ASC) {
      nodes {
        id
        _rowTimestamp
        approvalLevel
        name
        description
        _isUpdatable
        _isDeletable
        requiredBranchApprovalCount
        isApprovedByConsensus
        isSingleDeclineConsensusInvoked
        isRejectOnUnderApprovalCount
        isUsedForAdditionalDepartments
        approvalBranches(orderBy: BRANCH_ORDER_ASC) {
          nodes {
            id
            _rowTimestamp
            _isUpdatable
            _isDeletable
            branchOrder
            description
            userOccupation {
              id
              userOccupationTitle
            }
            userRank {
              id
              userRank
            }
            budgetLimitAmount
            budgetLimitPercent
            isBusinessUnitSelector
            isUserGroupSelector
            isWorkgroupSelector
            requesterUserId
            isProjectSelector
            isDepartmentSelector
            isOverBudgetSelector
            transactionStartAmountTotal
            transactionEndAmountTotal
            transactionAmountConversionTypeId
            approverTransactionTypeId
            transactionBusinessUnitId
            transactionDepartmentId
            transactionDepartmentGroupId
            isTransactionNotCondition
            approverDelayDays
            approverDelayHours
            approverDelayStatusTypeId
          }
        }
      }
    }
    approvalSelectionConditions(orderBy: IMPORTANCE_LEVEL_ASC) {
      nodes {
        id
        approvalId
        importanceLevel
        description
        startAmountTotal
        endAmountTotal
        _isUpdatable
        _isDeletable
        _rowTimestamp
        requesterCurrencyId
        amountConversionTypeId
        requesterUserOccupationTitleId
        requesterDepartmentId
        requesterDepartmentTypeId
        requesterDepartmentGroupId
        requesterSecureRowLevelId
        startElapsedDays
        endElapsedDays
        requesterTagId
        isAndCondition
        requesterUserRankId
        requesterCompanyId
        requesterBusinessUnitId
        requesterUserId
        requesterPurchaseOrderTypeId
        isAutoApprovedEligible
        approval {
          statusType {
            statusType
          }
        }
      }
      totalCount
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
    }
    approvalSetupHistoriesByEntityId {
      nodes {
        tenantUserName
        pointInTimeDate
        crudOperation
      }
    }
  }
}
